'use strict';

var Substance = require('../basics');

function Operation() {
}

Operation.Prototype = function() {

  this.isOperation = true;

};

Substance.initClass(Operation);

module.exports = Operation;


/*****************
 ** WEBPACK FOOTER
 ** ./~/substance/operator/operation.js
 ** module id = 32
 ** module chunks = 0
 **/